import { faPlus, faTrashCan, faListUl, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { Nav } from 'react-bootstrap';
import ProjectsTopSection from '../../components/project-management/ProjectsTopSection';
import ProjectListTable, {
  projectListTableColumns
} from '../../components/tables/ProjectListTable';
import { projects } from '../../data/project-management/projects';
import useAdvanceTable from '../../hooks/useAdvanceTable';
import AdvanceTableProvider from '../../providers/AdvanceTableProvider';
import { Link } from 'react-router-dom';
import { Bars } from 'react-loader-spinner';
import { useJobs } from '../../features/jobs/hooks/useJobs.js';
import { useArchivedJobs } from '../../features/jobs/hooks/useArchivedJobs.js';
import { adaptJobToProjectRow } from '../../helpers/jobsAdapter.js';
import { useMemo, useState } from 'react';
import CompletedProjectsPanel from '../../components/project-management/CompletedProjectsPanel';
import { jobSearchKey, matchesSearch } from '../../helpers/cableSearch.js';

const ProjectListView = () => {
  const [view, setView] = useState('active'); // 'active' | 'deleted'
  const { data: jobs = [], isLoading } = useJobs();
  const { data: archived = [], isLoading: archLoading } = useArchivedJobs(
    view === 'deleted'
  );

  const source = view === 'deleted' ? archived : jobs;
  const tableData = useMemo(
    () =>
      source.map(j => ({
        ...adaptJobToProjectRow(j),
        _deleted: view === 'deleted',
        _archivedAt: j._archivedAt || null,
        _archivedReason: j._archivedReason || null
      })),
    [source, view]
  );

  const table = useAdvanceTable({
    data: tableData,
    columns: projectListTableColumns,
    pageSize: 6,
    pagination: true,
    sortable: true,
    // Same search rule as the Projects table on Project Monitor — one shared
    // search box, so it cannot answer differently depending on which view the
    // planner happens to be in.
    globalFilterFn: (row, _columnId, value) =>
      matchesSearch(jobSearchKey(row.original), value)
  });

  const loading = view === 'deleted' ? archLoading : isLoading;

  if (loading && !tableData.length)
    return (
      <Bars
        height="80"
        width="80"
        radius="9"
        color={'#3874ff'}
        ariaLabel="three-dots-loading"
        wrapperStyle={styles.spinnerContainer}
      />
    );

  return (
    <div>
      {/* <PageBreadcrumb items={defaultBreadcrumbItems} /> */}
      <AdvanceTableProvider {...table}>
        <div className="d-flex flex-wrap mb-4 gap-3 gap-sm-6 align-items-center">
          <h2 className="mb-0">
            <span className="me-3">
              {view === 'deleted' ? 'Deleted projects' : 'Projects'}
            </span>{' '}
            <span className="fw-normal text-700">({tableData.length})</span>
          </h2>
          <Link
            className="btn btn-primary px-5"
            to="/apps/project-management/create-new"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Add new project
          </Link>
        </div>
        <Nav variant="pills" className="mb-3 gap-2">
          <Nav.Item>
            <Nav.Link
              active={view === 'active'}
              onClick={() => setView('active')}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faListUl} className="me-2" />
              Active
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={view === 'completed'}
              onClick={() => setView('completed')}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faCircleCheck} className="me-2" />
              Completed
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={view === 'deleted'}
              onClick={() => setView('deleted')}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faTrashCan} className="me-2" />
              Deleted
            </Nav.Link>
          </Nav.Item>
        </Nav>
        {view === 'completed' ? (
          <CompletedProjectsPanel />
        ) : (
          <>
            {view === 'active' && <ProjectsTopSection activeView="list" />}
            <ProjectListTable />
          </>
        )}
      </AdvanceTableProvider>
    </div>
  );
};

const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Add a background with some opacity
    zIndex: 1000 // Ensure the spinner is on top
    // backgroundColor: '#000', // Optional: background color
  }
};

export default ProjectListView;
